@if (visible) {
  <div class="bar-container" [class.complete-animate]="complete" clickOutside (clickOutside)="openSetupGuide = false">
    <div class="row notification setup-guide clickable" (click)="complete ? null : toggleSetupGuide()">
      <div class="col text-center">
        <div class="d-flex justify-content-between align-items-center">
          @if (setupPercentageComplete < 100) {
            <p>
              {{'SETUP_GUIDE.almostReady' | translate}} 🚀
            </p>
          }
          @if (setupPercentageComplete >= 100) {
            <p class="text-nowrap">
              {{'SETUP_GUIDE.extraReady' | translate}}
            </p>
          }
          <div class="d-flex item align-items-center">
            <div class="d-flex align-items-center">
              <div class="progress setup-progress">
                <div class="progress-bar" role="progressbar" [ngStyle]="{width: setupPercentageComplete + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div class="percent-indicator">{{setupPercentageComplete}}%</div>
            </div>
            <i class="material-icons ico-arrow" [ngClass]="{'ico-up': openSetupGuide}">keyboard_arrow_down</i>
          </div>
        </div>
      </div>
    </div>
    <div class="setup-guide-menu text-center" [ngClass]="{'open': openSetupGuide}">
      <!-- Setup steps -->
      @if (currentPage === 0) {
        @if ((setupSteps.length - completedSetupStepsLength) > 1) {
          <p>{{'SETUP_GUIDE.stepsLeft' | translate: {steps: (setupSteps.length - completedSetupStepsLength)} }}!</p>
        }
        @if ((setupSteps.length - completedSetupStepsLength) === 1) {
          <p>{{'SETUP_GUIDE.stepLeft' | translate: {steps: (setupSteps.length - completedSetupStepsLength)} }}!</p>
        }
        @for (step of setupSteps; track step) {
          <ng-container *ngTemplateOutlet="stepTemplate;context:{ $implicit: step }"  />
        }
        @if (shouldShowFlashSale) {
          <button type="button" class="btn btn-md btn-upgrade w-100 mt-2 mb-1" (click)="showFlashPromo()">Plano PRO 3x1</button>
        }
        <button type="button" class="btn btn-md btn-primary mt-2 mb-1" (click)="toggleSetupGuide()">{{'GENERAL.close' | translate}}</button>
      }
      <!-- Extra Steps -->
      @if (currentPage === 1) {
        @if (remainingExtraStepsLength === 1) {
          <p class="text-bold mb-3">
            {{'SETUP_GUIDE.extraStepLeft' | translate: {steps: remainingExtraStepsLength} }}
          </p>
        }
        @if (remainingExtraStepsLength > 1) {
          <p class="text-bold mb-3">
            {{'SETUP_GUIDE.extraStepsLeft' | translate: {steps: remainingExtraStepsLength} }}
          </p>
        }
        <!-- <ng-container *ngFor="let step of extraSteps" >
        <ng-container *ngTemplateOutlet="stepTemplate;context:{ $implicit: step }" ></ng-container>
      </ng-container> -->
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-md btn-primary mt-2 mb-1" (click)="setTourAsCompleted()">{{'SETUP_GUIDE.noThankYou' | translate}}</button>
        <button type="button" class="btn btn-md btn-primary mt-2 mb-1" (click)="toggleSetupGuide()">{{'GENERAL.close' | translate}}</button>
      </div>
    }
  </div>
</div>
}

<ng-template #stepTemplate let-step>
  <span class="btn-step" [class.step-done]="step.completed" (click)="clickStep(step.id)">
    <div class="item d-flex align-items-center">
      <i class="material-icons ico-check mr-2">check_circle</i>
      <p>{{step.title}}</p>
    </div>
    @if (!step.completed) {
      <i class="material-icons ico-arrow">keyboard_arrow_right</i>
    }
  </span>
</ng-template>

<ng-template #completeModalTemplate>
  <div class="modal-body modal-finish px-4">
    <div class="md-header text-center pt-4">
      <i class="material-icons ico-check">check_circle</i>
      <h3>{{'SETUP_GUIDE.titleSuccess' | translate}}</h3>
      <p class="text-secondary mb-4">{{'SETUP_GUIDE.descSuccess' | translate}}</p>
      <button type="button" class="btn btn-md btn-primary" (click)="tourFinish()">{{'SETUP_GUIDE.ctaSuccess' | translate}}</button>
    </div>
  </div>
</ng-template>